import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HenterPantComponent } from './henter-pant.component';
import { ProfileComponent } from "./profile/profile.component";
import { SharedModule } from "../../shared.module";
import { HenterPantRoutingModule } from "./henter-pant-routing.module";
import { SportTypePipe } from "../../pipes/sport-type.pipe";



@NgModule({
  declarations: [
    HenterPantComponent,
    ProfileComponent
  ],
  imports: [
    CommonModule,
    HenterPantRoutingModule,
    SharedModule
  ]
})
export class HenterPantModule { }
